import { ReactNode, useEffect, useRef } from "react";

import { dropTargetForElements } from "@atlaskit/pragmatic-drag-and-drop/element/adapter";

import { ElementsAndSectionsBehaviour } from "./behaviours";
import { ITEM_TYPES } from "./types";

interface SectionsContainerProps {
    className?: string;
    children?: ReactNode;
    elementsAndSectionsBehaviour: ElementsAndSectionsBehaviour;
}
export function SectionsContainer(props: SectionsContainerProps) {
    const { className, children, elementsAndSectionsBehaviour } = props;
    const enabled = elementsAndSectionsBehaviour.type !== "FIXED";

    const ref = useRef<HTMLDivElement>(null);

    // Register the outer container as a fallback drop target; hovering it
    // (and nothing deeper) signals "not over a section" so we can invalidate.
    useEffect(() => {
        const el = ref.current;
        if (!el || !enabled) {
            return;
        }
        return dropTargetForElements({
            element: el,
            canDrop: ({ source }) => {
                const t = source.data.type;
                return (
                    t === ITEM_TYPES.BUTTON ||
                    t === ITEM_TYPES.ELEMENT ||
                    t === ITEM_TYPES.SECTION
                );
            },
            getData: () => ({ dropKind: "CONTAINER" as const }),
        });
    }, [enabled]);

    return (
        <div ref={ref} className={className}>
            {children}
        </div>
    );
}
